import { json, type LoaderFunctionArgs, type MetaFunction } from '@remix-run/node'
import { Compound } from '#app/ui/sections/home/compound.tsx'
import { CTA } from '#app/ui/sections/home/cta.tsx'
import { FAQ } from '#app/ui/sections/home/faq.tsx'
import { Founder } from '#app/ui/sections/home/founder.tsx'
import { Hero } from '#app/ui/sections/home/hero.tsx'
import { Problem } from '#app/ui/sections/home/problem.tsx'
import { Process } from '#app/ui/sections/home/process.tsx'
import { Services } from '#app/ui/sections/home/services.tsx'
import { Testimonial } from '#app/ui/sections/home/testimonial.tsx'
import { appName } from '#app/utils/constants.ts'
import i18next from '#app/utils/locale.server.ts'
import { getRequestInfo, socialMeta } from '#app/utils/seo.ts'

export const handle = { i18n: 'home' }

export async function loader({ request }: LoaderFunctionArgs) {
	const t = await i18next.getFixedT(request, 'home')
	return json({
		title: t('meta.title', { appName }),
		description: t('meta.description'),
	})
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) =>
	socialMeta({
		title: data?.title ?? `${appName} — Helping businesses create abundance`,
		description:
			data?.description ??
			"A growing business doesn't take a bigger slice — it makes something that wasn't there before.",
		requestInfo: getRequestInfo(matches),
	})

export default function Index() {
	return (
		<>
			<Hero />
			<Problem />
			<div id="what-i-build" className="scroll-mt-24">
				<Services />
				<Compound />
			</div>
			<Process />
			<Founder />
			<Testimonial />
			<FAQ />
			<CTA className="mb-fluid-16" />
		</>
	)
}
